"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAvatar = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const AvatarDefaultSrc_1 = require("./helpers/AvatarDefaultSrc");
const helpers_1 = require("../helpers");
exports.StyledAvatar = styled_components_1.default.span `
    display: inline-block;
    height: ${helpers_1.SIZE_XL};
    width: ${helpers_1.SIZE_XL};
    vertical-align: top;
    background-color: ${({ backgroundColor }) => backgroundColor};
    ${({ rounded = true, src }) => rounded && src !== AvatarDefaultSrc_1.DEFAULT_AVATAR_SRC ? `border-radius: 50%;` : ''}

    ${({ src }) => {
    if (react_1.default.isValidElement(src)) {
        return (0, styled_components_1.css) `
                overflow: hidden;

                svg {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            `;
    }
    return (0, styled_components_1.css) `
            background-image: url(${src});
            background-repeat: no-repeat;
            background-position: 0 0;
            background-size: contain;
        `;
}}
`;
//# sourceMappingURL=Avatar.styles.js.map